export default __webpack_public_path__ + "static/media/Transition_Start-OTEL.805db685.mp4";